/**
 * Language: Italian.
 */
export default {
    "messages": {
        "choose_thematic": "Scegli Tematica",
        "sessionReset": "La sessione si reimposterà automaticamente tra",
        "minute": "minuto",
        "resetMap": "Reimposta Mappa",
        "selectLanguage": "Seleziona una Lingua",
        "seconds": "secondi",
        "cta": {
            "switch_standard_view": "Passa alla visualizzazione standard"
        },
        "minutes": "minuti",
        "multilevelwarning": "Questo percorso è su due livelli e passa anche per il Quick Link a livello 1",
        "allexhibits": "Tutti gli espositori",
        "favorites": "Espositori da visitare",
        "select_thematic": "Percorsi tematici",
        "add_favorites": "Aggiungi ai tuoi espositori",
        "remove_favorites": "Rimuovi",
        "add_favorites_toast": "Aggiunto alla lista degli espositori che vuoi visitare",
        "remove_favorites_toast": "Rimosso degli espositori che vuoi visitare",
        "level": "Livello",
        "allexhibits_mobile": "Tutti gli espositori",
        "favorites_mobile": "Espositori da visitare",
        "select_thematic_mobile": "Percorsi a tema",
        "api_error": "Devi effettuare il login per accedere ai tuoi espositori",
        "destination": "Destinazione",
        "origin": "Partenza",
        "sponsored_logo_selection": "Clicca sul logo del brand per visualizzare la posizione lo stand",
        "to_visit": "Visitato",
        "visited_toast": "Espositore contrassegnato come visitato",
        "unvisited_toast": "Esposizione non più segnato come visitato"

    },
    "thematics": {
        "umbrella": "Ombrelloni e pergole",
        "smartoffice": "Smart Office",
        "eclectic": "Eclectic Design",
        "dol": "Domestic Outdoor lighting",
        "uol": "Urban Outdoor lighting",
        "homent": "Home Entertainment",
        "wallpaper": "Wallpaper",
        "rug": "Tappeti",
    },
    "thematicDescription": {
        "outdoor": "Design, durabilità e comfort: evoluzione continua per arredare giardini, terrazzi e spazi di piccole dimensioni.",
        "textile": "Percorsi tessili che intrecciano tecnologie più avanzate e inconfondibile segno artigianale.",
        "wallpaper": "Soluzioni e ricerche tra materiali, pattern e colori che uniscono tecnica ed estetica.",
        "kitchen": "Progetti, arredi su misura e soluzioni per hotel, residence, uffici e retail.",
        "bathroom": "Arredi ad alto tasso di innovazione: la sostenibilità idrica secondo Salotto NY.",
        "umbrella": "Lorem ipsum dolor sit amet consectetur adipiscing elit. Dolor sit amet consectetur adipiscing elit quisque faucibus.",
        "smartoffice": "Adipiscing elit quisque faucibus ex sapien vitae pellentesque.",
        "eclectic": "Vitae pellentesque sem placerat in id cursus mi. Cursus mi pretium tellus duis convallis tempus leo.",
        "dol": "Tempus leo eu aenean sed diam urna tempor. Urna tempor pulvinar vivamus fringilla lacus nec metus.",
        "uol": " Semper vel class aptent taciti sociosqu ad litora. Conubia nostra inceptos himenaeos orci varius natoque penatibus.",
        "homent": "Dis parturient montes nascetur ridiculus mus donec rhoncus.",
        "rug": "Nulla molestie mattis scelerisque maximus eget fermentum odio. Purus est efficitur laoreet mauris pharetra vestibulum fusce."
    },
    "errors": {
        "loadingLibrary": "Impossibile caricare lo script {library}",
        "geolocationFailed": "Geolocalizzazione dell'utente fallita",
        "apiErrors": {
            "401": "Non autorizzato",
            "403": "Vietato",
            "429": "Troppe richieste",
            "500": "Errore interno del server",
            "other": "Si è verificato un errore imprevisto del server"
        }
    },
    "keyboard": {
        "space": "Spazio",
    },
    "indoor": {
        'Search': 'Cerca',
        'Itinerary': 'Itinerario',
        'Monday': 'Lunedì',
        'Tuesday': 'Martedì',
        'Wednesday': 'Mercoledì',
        'Thursday': 'Giovedì',
        'Friday': 'Venerdì',
        'Saturday': 'Sabato',
        'Sunday': 'Domenica',
        'levels': 'Livelli',
        'level': 'Livello',
        'Level': 'Livello',
        'Select Positions': 'Seleziona un punto di partenza e una destinazione',
        'Type a origin': 'Punto di partenza',
        'Type a destination': 'Destinazione',
        'No route found': 'Nessun percorso trovato',
        'Shops': 'Negozi',
        'at Level': 'al Livello',
        'At': 'A',
        'up': 'su',
        'down': 'giù',
        'Your Location': 'La tua posizione',
        'Accessible for people with disabilities': 'Accessibile alle persone con disabilità',
        'Navigate': 'Naviga',
        'Then': 'Poi',
        'you are arrived': 'sei arrivato',
        'Overview': 'Panoramica',
        'Center': 'Centra',
        'Less than 1min': "Meno di 1 minuto",
        'Next': "Successivo",
        'Previous': "Precedente",
        'Quit': "Esci",
        'Resume': "Riprendi",
        'in': "in",
        'Open': "Aperto",
        'Closed': "Chiuso",
        'Closes at': "Chiude alle",
        'Opens': "Apre",
        'tomorrow': "domani",
        'at': 'alle',
        'Select a location and a destination': "Seleziona un luogo e una destinazione",
        'Disability compliant': "Percorso accessibile",
        'ETA': "Tempo stimato di arrivo",
        'search_stop': "Cerca brand...",
        "stop_cta": "Aggiungi fermate",
        "stop_search_label": "Aggiungi fermate intermedie",
        "steps": "tappe",
        "optimized_route_cta_label": "Crea percorso personalizzato",
        "optimized_route_cta_desc": "Ottimizza il tuo percorso per visitare i tuoi espositori preferiti.",
        "optimized_route_cta_button": "Crea il tuo percorso",
        "route_loader_header": "È in corso l’ottimizzazione del percorso",
        "route_loader_title": "Stiamo cercando il percorso migliore per la tua visita",
        "route_panel_title": "Crea percorso peronalizzato",
        "route_field_origin_label": "Partenza",
        "route_field_des_label": "Arrivo",
        "exit_gate_label": "Indica la porta di uscita",
        "cancel": "Annulla",
        "from": "da",
        "to": "a",
        "results_summary_header": "percorso ottimizzato",
        "edit": "modifica",
        "start_navigation": "Avvia navigazione",
        "exit_gate_warning": "Selezionando l'uscita della fiera, sovrascrivi la destinazione finale del percorso",
        "duplicate_stop_warning": "La tappa è già presente nel percorso",
        "for": "per",
        "go_to_stop": "vai a tappa",
        "of": "di",
        "meters": "metri",
        "Pause": "Pausa",
        "Steps": "Tappe",
        "leg_step": "Step",
        "final_destination": "Fine percorso",
        "max_stop_limit_warning": "Limite massimo di tappe raggiunto",
        "set_as_origin": "Imposta come partenza",
        "set_as_destination": "Imposta come arrivo",
        "same_origin_destination_warning": "Partenza e arrivo non possono essere uguali",
        "fav_route_builder_heading": "La tua lista di espositori da visitare",
        "fav_route_builder_sub_heading": "Seleziona fino ad un massimo di 15 espositori ed imposta partenza e arrivo per creare il percorso personalizzato",
        "fav_route_builder_selected_exhibitors": "Espositori selezionati:",
        "fav_route_builder_min_stop_message": "Seleziona almeno 3 espositori che desideri visitare per creare il tuo percorso personalizzato.",
        'destination_in_sight': 'Destiazione invista!',
        'continue_to_reach': 'Continua per {distance} per raggiungere {name}',
        'unauthorised_favs': 'Accedi e seleziona gli espositori che desideri visitare per creare il tuo percorso personalizzato.',
        'unauthorized_map_toast': 'Accedi per creare e visualizzare la tua lista di espositori personalizzata',
        'empty_map_toast': 'Cerca un espositore oppure tocca il suo nome sulla mappa per aggiungerlo alla lista degli espositori che vuoi visitare',
        "edit_stops": "Modifica tappe",
        "route_builder_toast": "Imposta origine e destinazione per ottimizzare il percorso."
    }
};
